import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

import { Tag } from '@ontruck/orc';

const tagColorByStatus = {
  PENDING_MODERATION: 'white',
  PENDING_ASSIGNMENT: 'white',
  ASSIGNED: 'white',
  IN_TRANSIT: 'white',
  DONE: 'green',
  DONE_WITHOUT_MANIFEST: 'green',
  DONE_WITH_CANCELLATIONS: 'green',
  CANCELLED: 'red',
};

const statusHumanNameMap = {
  PENDING_MODERATION: 'In queue',
  PENDING_ASSIGNMENT: 'Unassigned',
  ASSIGNED: 'Assigned',
  IN_TRANSIT: 'In transit',
  DONE: 'Finished',
  DONE_WITHOUT_MANIFEST: 'Finished w/o POD',
  CANCELLED: 'Cancelled',
};

const StatusCell = ({ status }) => (
  <Fragment>
    <Tag
      skin={tagColorByStatus[status] || 'white'}
      text={statusHumanNameMap[status] || 'Unknown'}
    />
  </Fragment>
);

StatusCell.propTypes = {
  status: PropTypes.string.isRequired,
};

export default StatusCell;
